"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _Portal = _interopRequireDefault(require("./Portal"));
var _calculateTooltipAdjustment = _interopRequireDefault(require("./utils/tooltip/calculateTooltipAdjustment"));
var _resolvePositioning = _interopRequireWildcard(require("./utils/tooltip/resolvePositioning"));
var _Tooltip = _interopRequireDefault(require("./styles/Tooltip"));
var _excluded = ["className", "contentId", "text", "children", "allowWrapping", "usePosition", "delay", "center", "highlight", "isEnabled", "attachTo"],
  _excluded2 = ["hovered"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function Tooltip(_ref) {
  var className = _ref.className,
    contentId = _ref.contentId,
    text = _ref.text,
    children = _ref.children,
    _ref$allowWrapping = _ref.allowWrapping,
    allowWrapping = _ref$allowWrapping === void 0 ? false : _ref$allowWrapping,
    _ref$usePosition = _ref.usePosition,
    usePosition = _ref$usePosition === void 0 ? false : _ref$usePosition,
    _ref$delay = _ref.delay,
    delay = _ref$delay === void 0 ? 0 : _ref$delay,
    _ref$center = _ref.center,
    center = _ref$center === void 0 ? false : _ref$center,
    _ref$highlight = _ref.highlight,
    highlight = _ref$highlight === void 0 ? false : _ref$highlight,
    _ref$isEnabled = _ref.isEnabled,
    isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled,
    attachTo = _ref.attachTo,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var timer = (0, _react.useRef)();
  var tooltip = (0, _react.useRef)();
  var _useState = (0, _react.useState)({
      hovered: false,
      at: [],
      adjustment: null
    }),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    _useState2$ = _useState2[0],
    hovered = _useState2$.hovered,
    other = (0, _objectWithoutProperties2["default"])(_useState2$, _excluded2),
    setHovered = _useState2[1];

  // Clear timeout on unmount
  (0, _react.useEffect)(function () {
    return function () {
      return clearTimeout(timer.current);
    };
  }, []);
  var style = (0, _resolvePositioning["default"])(tooltip, other, usePosition, center);
  function handleEnter() {
    if (!isEnabled) {
      return;
    }
    var _calculateTooltipAdju = (0, _calculateTooltipAdjustment["default"])(tooltip.current, {
        usePosition: usePosition,
        center: center
      }),
      adjustment = _calculateTooltipAdju.adjustment,
      clientX = _calculateTooltipAdju.clientX,
      clientY = _calculateTooltipAdju.clientY;
    clearTimeout(timer.current);
    timer.current = setTimeout(function () {
      setHovered({
        hovered: true,
        at: [clientX, clientY],
        adjustment: adjustment
      });
    }, delay);
  }
  function handleLeave() {
    if (!isEnabled) {
      return;
    }
    clearTimeout(timer.current);
    setHovered({
      hovered: false,
      at: [],
      adjustment: null
    });
  }
  var TooltipContent = function TooltipContent(_ref2) {
    var hidden = _ref2.hidden,
      readable = _ref2.readable;
    return /*#__PURE__*/_react["default"].createElement("div", {
      id: readable && contentId || undefined,
      style: style,
      "aria-hidden": !readable,
      className: (0, _classnames["default"])('tooltip__content', _Tooltip["default"].tooltipContent, attachTo && _Tooltip["default"].tooltipContent__inPortal, !hidden && [hovered && _Tooltip["default"].tooltipContent__hovered, allowWrapping && _Tooltip["default"].tooltipContent__wrap, usePosition && _Tooltip["default"].tooltipContent__fixed, center && _Tooltip["default"].tooltipContent__center])
    }, text);
  };
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    ref: tooltip,
    className: (0, _classnames["default"])('tooltip', _Tooltip["default"].tooltip, className, [highlight && hovered && _Tooltip["default"].tooltip__highlight]),
    onMouseEnter: handleEnter,
    onMouseLeave: handleLeave
  }, props), /*#__PURE__*/_react["default"].createElement(TooltipContent, {
    hidden: !!attachTo,
    readable: !!isEnabled
  }), isEnabled && hovered && attachTo && /*#__PURE__*/_react["default"].createElement(_Portal["default"], {
    querySelector: attachTo
  }, /*#__PURE__*/_react["default"].createElement(TooltipContent, {
    readable: false
  })), children);
}
Tooltip.displayName = 'Tooltip';
var _default = exports["default"] = Tooltip;